/**
 * 여권 영문 이름 입력값 정리 — 영문·공백만 남긴다.
 * 첫 글자 공백이나 연속 공백처럼 받지 말아야 할 입력이면 null (기존 값 유지).
 */
export const sanitizeEnglishName = (value: string): string | null => {
  // 문서에서 붙여넣은 특수 공백(NBSP·탭 등)은 일반 공백으로 — 서버는 일반 공백만 받는다
  const normalizedValue = value.replace(/\s/g, ' ');
  if (normalizedValue === ' ') return null;

  const filteredValue = normalizedValue.replace(/[^a-zA-Z ]/g, '');
  if (/ {2,}/.test(filteredValue)) return null;

  return filteredValue;
};

/**
 * 저장된 이름이 여권 영문 이름으로 쓸 만한지 — 서버 MemberNamePolicy 와 같은 규칙.
 * 입력칸(sanitizeEnglishName)보다 넓어서, 예전에 저장된 하이픈 이름(Hsin-Chieh)도 통과한다.
 */
export const isPassportName = (value: string | null | undefined): value is string =>
  !!value && value.length <= 100 && /^[A-Za-z][A-Za-z .'-]*$/.test(value);
